// extracted by mini-css-extract-plugin
export default {"full-width-tooltip-wrapper":"hwblhQJrMF5jU_rZ0yWI"};